<template>
  <div class="">
    <card back>
      <template slot="header">
        <h5 class="d-inline">استعلام صورتــــحساب ها</h5>
        <hr />
      </template>
      <template slot="content">
        <ChackupTaxSale @StateMojavez="StateMojavez"></ChackupTaxSale>
        <BnpGrid v-if="MojavezPage" :key="Render" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :action="true" :NoPagination="false" >
          <template slot="action-slot" slot-scope="props">
            <button class="btn btn-success" v-if="props.props.status != ' SUCCESS'"  @click="Inquery(props.props)">استعلام</button>
          </template>
          <template slot="status" slot-scope="props">
            <span class="">{{ props.props.status == 'Wating' ? 'درحال انتظار استعلام' : props.props.status == ' FAILED' ? 'معـــلق' : props.props.status == ' SUCCESS'?'ثبت موفق':'نامشخص' }}</span>
          </template>          
          <template slot="tblUserGrpIdInsert" slot-scope="props">
            <span dir="rtl">{{ props.porps.tblUserGrpIdInsert.slice(0,10) }}</span>
          </template>
          <template slot="MetaSlot">
            <select class="form-control w-50 d-inline Pointer" v-model="Filter">
              <option value="Wating">درحال انتظار استعلام</option>
              <option value=" SUCCESS">ثبت موفق</option>
              <option value="Other">وضعیت های دیگر</option>
              <option value=""> همه </option>
            </select>
            <button class="btn btn-success d-inline mr-1" @click="Get"><i class="fad fa-search ml-2"></i> اعمال فیلــــــتر </button>
          </template>
        </BnpGrid>
      </template>
    </card>
    <modal v-if="ShowModalDetail" @Close="Close" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
      <template v-slot:body>
        <div class="row mx-3">
          <div class="col-12 alert alert-danger">
            <div class="" style="font-size:18px;">نکته : </div>
            <div class="text-right mt-2" style="font-size:14px;"> لیست خطاهای زیر حتما باید اصلاح شود تا امکان ثبت در سامانه مودیان فراهم شود و تا زمانی که فایل شما دارای خطا باشد وضعیت صورتحساب شما به صورت معلق خواهد ماند</div>
            <div class="text-right mt-2" style="font-size:14px;"> لیست هشدار ها بهتر است در صورت امکان برطرف گردد اما الزامی در رفع آنها نیس و صرفا جهت اطلاع شما می باشد</div>
          </div>

          <div class="col-12 text-danger text-center" v-if="ErrorList.length > 0">
            <h5>لیست خطاهای استعــــلام</h5>
          </div>
          <div class="col-12" v-if="ErrorList.length > 0">
            <BnpGrid v-if="ErrorList.length > 0" :key="RenderError" :hasRowNum="true" :propsColumn="ColumnError" :propsRows="ErrorList" :action="false" :NoPagination="ErrorList.length > 10 ? false : true" :NoSearch="true"> </BnpGrid>
            <hr />
          </div>

          <div class="col-12 text-center mt-5" v-if="WarningList.length > 0">
            <h5>لیست هشدارهای استعــــلام</h5>
          </div>
          <div class="col-12" v-if="WarningList.length > 0">
            <BnpGrid v-if="WarningList.length > 0" :key="RenderError" :hasRowNum="true" :propsColumn="ColumnWarning" :propsRows="WarningList" :action="false" :NoPagination="WarningList.length > 10 ? false : true" :NoSearch="true"> </BnpGrid>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Card from '@/components/Card/Card.vue'
import ChackupTaxSale from '../ChackupTaxSale.vue'
import Modal from '@/pages/Modal/Modal.vue'
export default {
  components: { Card, BnpGrid, ChackupTaxSale, Modal },
  data() {
    return {
      Rows: [],
      Column: [],
      Render: 0,
      RenderError: 0,
      Column: [
        {
          name: 'taxid',
          label: 'شناسه مالیاتی صورتحساب',
          visibility: true,
        },
        {
          name: 'uid',
          label: 'شناسه صورت حساب',
          visibility: true,
        },
        {
          name: 'referenceNumber',
          label: 'کد رهگیری مرحله ارسال',
          visibility: true,
        },
        {
          name: 'status',
          label: 'وضعیت',
          visibility: true,
        },
        {
          name: 'confirmationReferenceId',
          label: 'شماره رهگیری تایید',
          visibility: true,
        },{
          name: 'dateTimeInsert',
          label: 'تاریخ ثبت',
          visibility: true,
        },
      ],
      ShowPageNation: true,
      MojavezPage: false,
      ShowModalDetail: false,
      ErrorList: [],
      WarningList: [],
      ColumnError: [
        {
          name: 'code',
          label: 'کد خطا',
          visibility: true,
        },
        {
          name: 'msg',
          label: 'متن خطا',
          visibility: true,
        },
      ],
      ColumnWarning: [
        {
          name: 'code',
          label: 'کد خطا',
          visibility: true,
        },
        {
          name: 'msg',
          label: 'متن هشدار',
          visibility: true,
        },
      ],
      Filter:'Wating'
    }
  },
  methods: {
    Get() {
      var SendData = { Action: 'InqueryInvoice', Method: 'POST', ArryfildValue: null }
      var formData = new FormData()
      formData.append('tblCustomerId', this.$session.get('CustomerInfo').Id)
      formData.append('Status', this.Filter)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        if (result.status == 'Not Ok') {
          this.$toasted.error(result.msg, { duration: 3000 })
        }
        if (result.status == 'Ok') {
          this.Rows = result.data
          console.log("😎 ~ this.$PostFormData ~ this.Rows:", this.Rows)
          // this.ShowPageNation = true
          // this.Rows.length > 10 ? (this.ShowPageNation = false) : (this.ShowPageNation = true)
          this.Render++
        }
      })
    },
    StateMojavez(val) {
      this.MojavezPage = val
      this.Get()
    },
    Inquery(row) {
      let Obj = { ReferenceNumber: row.referenceNumber, tblCustomerId: this.$session.get('CustomerInfo').Id }
      let DataAxiosSend = { Action: 'Tax/InqueryResualt', Method: 'POST', ArryfildValue: Obj }
      this.$PostData(DataAxiosSend).then((result) => {
        if (result.status == 'SUACCESS') {
          this.$toasted.success('استعلام انجام شد', { durations: 3000 })
          let refId = result.refID
          let Result = result.result
          this.ErrorList = result.erorrs
          this.WarningList = result.warnings
          this.ShowModalDetail = true
          row.status = Result.split('=')[1]
          row.confirmationReferenceId = refId.split('=')[1]
          this.RenderError++
          this.UpdateStatus(row)
        } else {
          this.$toasted.error('استعلام ناموفق بود لطفا بعد از چند دقیقا تلاش کنید', { durations: 3000 })
        }
      })
    },
    Close() {
      this.ShowModalDetail = false
    },
    UpdateStatus(row) {
      let DataAxiosSend = { Action: 'InqueryInvoice/UpdateStatus', Method: 'POST', ArryfildValue: row }
      this.$PostData(DataAxiosSend).then((result) => {
        if (result.status!="Ok") {
          this.$toasted.error('خطایی در بروز رسانی اطلاعات رخ داد !',{ durations: 3000})
        }
        this.Render++
      })
    },
  },
  created() {},
}
</script>
